export const setworkspaces = (value: any) => {
	return {
		type: 'SET_WORKSPACES',
		payload: value,
	};
};
